<script lang="ts">
	import type { Board, GeneratedImage } from '$lib/diffusionApi';

	export let image: GeneratedImage;
	export let selectedBoard: Board;
	export let boardIdToBoardImagePinIdsMap: Map<string, string[]>;
	export let createPin: (image: GeneratedImage) => Promise<void>;
	export let deletePin: (image: GeneratedImage) => Promise<void>;
	export let clickBoardSelectorButton: (e: MouseEvent) => void;
</script>

<button
	data-related={`pin-button-${image.generation_id}`}
	type="button"
	class="w-[7.5rem] h-10 absolute top-1 left-1 flex flex-row justify-between items-center border rounded text-xs
	bg-primary-50 border-primary-200 text-zinc-900 hover:brightness-90
	dark:bg-zinc-900 dark:border-zinc-800 dark:text-zinc-200 dark:hover:brightness-150"
	on:click={clickBoardSelectorButton}
>
	<span
		class="w-24 flex flex-row justify-start items-center whitespace-nowrap overflow-x-clip ml-2 pointer-events-none"
		>{selectedBoard.name}</span
	>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class="w-5 h-5 pointer-events-none"
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
		/>
	</svg>
</button>
{#if !(boardIdToBoardImagePinIdsMap.get(selectedBoard.board_id) ?? []).includes(image.generation_id)}
	<button
		aria-label="Pin image"
		id={`pin-button-${image.generation_id}`}
		type="button"
		class="w-10 h-10 absolute top-1 right-1 border rounded text-md pin-controls
		bg-primary-50 border-primary-200 text-zinc-900 hover:brightness-90
		dark:bg-zinc-900 dark:border-zinc-800 dark:text-zinc-200 dark:hover:brightness-150"
		on:click={async (e) => {
			e.stopPropagation();
			e.preventDefault();
			await createPin(image);
		}}
	>
		<i class="fa-solid fa-thumbtack"></i>
	</button>
{:else}
	<button
		aria-label="Unpin image"
		id={`pin-button-${image.generation_id}`}
		type="button"
		class="w-10 h-10 absolute top-1 right-1 rounded text-md pin-controls
		bg-cyan-400 text-zinc-900 hover:brightness-90
		dark:text-zinc-800 dark:bg-zinc-300 dark:hover:brightness-90"
		on:click={async (e) => {
			e.stopPropagation();
			e.preventDefault();
			await deletePin(image);
		}}
	>
		<i class="fa-solid fa-thumbtack"></i>
	</button>
{/if}

<style>
</style>
